import React, { useEffect, useState } from 'react';
import { FormControl, Dropdown, InputGroup, Form, Row, Col, Button } from 'react-bootstrap';
import { ListItem } from '@mui/material';
import { IcoCross, Lens } from '@icons';
import { OETrans } from 'components/translation/OETrans';

const CustomMenu = React.forwardRef(({ children, style, className }, ref) => {
	const [value, setValue] = useState('');

	return (
		<div ref={ref} style={style} className={className}>
			<ListItem className="px-0 py-1">
				<InputGroup className="my-2">
					<FormControl
						type="text"
						style={{ borderRight: 0 }}
						className="px-2"
						placeholder="Cerca un SAL..."
						onInput={(e) => setValue(e.target.value)}
						value={value}
					/>
					<InputGroup.Text style={{ background: 'none' }}>
						<Lens />
					</InputGroup.Text>
				</InputGroup>
			</ListItem>

			<ul className="mb-0 px-0">
				{React.Children.toArray(children).filter((child) => !value || child.props.children.props.label.toLowerCase().includes(value))}
			</ul>
		</div>
	);
});

const DropdownSals = ({ optionsSals, originSelectedSals, selectedSals, setSelectedSals, setShowModalSampling, saveSals, handleTempInfoSampling }) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [tempSelectedSals, setTempSelectedSals] = useState([]);
	const [isDirty, setIsDirty] = useState(false);
	// console.log('isDirty', isDirty);

	useEffect(() => {
		setTempSelectedSals(selectedSals);
		setIsDirty(false);
	}, [selectedSals]);

	const onChange = (e, fieldName, setSelect) => {
		let value;
		if (!isDirty) setIsDirty(true);

		switch (fieldName) {
			case 'sals':
				value = e.target.checked;

				if (value) {
					setSelect((prev) => [...prev, { value: e.target.id, label: e.target.labels[0].innerText }]);
				} else {
					setSelect((prev) => prev.filter((item) => item.value !== e.target.id));
				}

				break;
			default:
				break;
		}
	};

	return (
		<Dropdown show={isDropdownOpen} onToggle={setIsDropdownOpen}>
			<Dropdown.Toggle variant="link" className="ms-auto no-underline text-lowercase" style={{ fontWeight: '500', color: '#06797F' }}>
				<span style={{ color: '#06797F' }}>aggiungi</span>
				<IcoCross className="ms-1" style={{ verticalAlign: 'text-top' }} />
			</Dropdown.Toggle>

			<Dropdown.Menu as={CustomMenu} className="dropdown-sals">
				<span style={{ maxHeight: '300px', overflowY: 'auto' }}>
					{optionsSals.map((opt, index) => (
						<Form.Check
							key={opt.value}
							type="checkbox"
							id={opt.value}
							label={opt.label}
							checked={tempSelectedSals?.some((sal) => sal.value === opt.value)}
							onChange={(e) => onChange(e, 'sals', setTempSelectedSals)}
						/>
					))}
				</span>

				<Row
					className="mt-3 justify-content-between"
					style={{
						backgroundColor: '#DEE4F1',
						padding: '24px 16px',
						margin: '0 -16px',
						borderBottomLeftRadius: '12px',
						borderBottomRightRadius: '12px',
					}}
				>
					<Col className="px-0">
						<Button
							className="new mini custom-outline-button me-3"
							style={{ fontWeight: '500' }}
							onClick={() => {
								setTempSelectedSals(originSelectedSals);
								setIsDropdownOpen(false);
							}}
						>
							<OETrans code="common.cancel" fallback={'Annulla'} />
						</Button>
					</Col>
					<Col className="px-0">
						<Button
							variant="primary"
							className="new mini custom-primary-button"
							style={{ fontWeight: '500' }}
							disabled={!isDirty}
							onClick={() => {
								//aggiungere logica per aggiornare i dati di infoPreSampling
								handleTempInfoSampling(tempSelectedSals);
								setIsDropdownOpen(false);
								setSelectedSals(tempSelectedSals);
							}}
						>
							Conferma
						</Button>
					</Col>
				</Row>
			</Dropdown.Menu>
		</Dropdown>
	);
};
export default DropdownSals;
